const appConfig = {
    appId: "salesQore-ff63b3d7-8141-4571-9032-0ca2f4f50e73",
    appName: "Sales",
    site: 'sales-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/salesQoreAppIcon.png"
};

export default appConfig;
